export default __webpack_public_path__ + "static/media/icon-close.3e88bd6e.svg";